<div class="left-align">
  <p class="title">{{ title | uppercase }}</p>
  @if (info) {
    <p class="time-period">
      {{ info() }}
    </p>
  }
</div>
<div class="right-align">
  <ng-content select="[right]"></ng-content>
  @if (info?.() !== 'NO DATA AVAILABLE') {
    <jmkw-slider
      [value]="opacity"
      (sliderChange)="changeOpacity($event)"
      >
    </jmkw-slider>
  }
  <button class="legend-close-btn" (click)="close()" title="Close"><i class="icon-cross"></i></button>
</div>
